export default [
  {
    path: '/contracts/list',
    name: 'ContractList',
    component: () => import('@/views/Contracts/ContractList.vue')
  },
  {
    path: '/contracts/update/:id',
    name: 'ContractUpdate',
    component: () => import('@/views/Contracts/ContractUpdate.vue')
  },
  {
    path: '/contracts/stages',
    name: 'ContractStageList',
    component: () => import('@/views/Contracts/ContractStageList.vue')
  },
  {
    path: '/contracts/status',
    name: 'ContractStatusList',
    component: () => import('@/views/Contracts/ContractStatusList.vue')
  },
  {
    path: '/contracts/types',
    name: 'ContractTypeList',
    component: () => import('@/views/Contracts/ContractTypeList.vue')
  },
  {
    path: '/contracts/projects',
    name: 'ContractProjectList',
    component: () => import('@/views/Contracts/ContractProjectList.vue')
  }
]
